//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '../../../src/lib/date';
import util from '@/lib/util';

export default {
    name: "activeDetail",
    components: {},
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, 'yyyy/MM/dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            id: 0,
            activity: {},
            downloadUrl: util.ApiUrl + 'file/download/',
            dateStr: '',
            isShowSignUpBtn: false,
            member: {},
            isShowCert: false,
            canSingUp: false,
            timeSlotList: [],
            showAction: true,
            signUpError: ''
        };
    },
    methods: {
        getActiveDetail() {
            var vm = this;

            vm.$store.dispatch({
                type: 'activity/GetActivityById',
                id: this.id
            }).then(res => {

                vm.activity = vm.$store.state.activity.activityInfo;
                var srr = vm.activity.startDateTime.split('T');
                var err = vm.activity.endDateTime.split('T');
                if (srr[0] == err[0]) {
                    this.dateStr = srr[0] + ' ' + srr[1].substring(0, 5) + '-' + err[1].substring(0, 5);
                    // this.dateStr = this.activity.startDateTime.substring(0, 16).replace('T', ' ') + '-' + this.activity.endDateTime.substring(0, 16).replace('T', ' ');
                } else {
                    this.dateStr = this.activity.startDateTime.substring(0, 16).replace('T', ' ') + '-' + this.activity.endDateTime.substring(0, 16).replace('T', ' ');
                }

                if (vm.activity.isSignUp) {
                    var sa = vm.$moment(vm.activity.signUpStartTime).isBefore(new Date());
                    var se = vm.$moment(vm.activity.signUpEndTime).isAfter(new Date());
                    if (sa && se) {
                        vm.isShowSignUpBtn = true;
                    } else {
                        vm.isShowSignUpBtn = false;
                        vm.signUpError = '不在报名时间内'
                    }
                } else {
                    vm.signUpError = '不需要报名'
                }
                console.log(vm.isShowSignUpBtn)
                this.$store.commit('activity/setJumpUrl', this.activity.jumpUrl);

            }).finally(() => {

            })
            // abp.ajax.get('/api/services/app/Activity/GetActivityById?id=' + this.id).then((res) => {
            //     vm.activity = res.data.result;
            //
            //     var srr = this.activity.startDateTime.split('T');
            //     var err = this.activity.endDateTime.split('T');
            //     if (srr[0] == err[0]) {
            //         this.dateStr = srr[0] + ' ' + srr[1].substring(0, 5) + '-' + err[1].substring(0, 5);
            //         // this.dateStr = this.activity.startDateTime.substring(0, 16).replace('T', ' ') + '-' + this.activity.endDateTime.substring(0, 16).replace('T', ' ');
            //     } else {
            //         this.dateStr = this.activity.startDateTime.substring(0, 16).replace('T', ' ') + '-' + this.activity.endDateTime.substring(0, 16).replace('T', ' ');
            //     }
            //
            //     if (vm.activity.isSignUp) {
            //         var sa = vm.$moment(vm.activity.signUpStartTime).isBefore(new Date());
            //         var se = vm.$moment(vm.activity.signUpEndTime).isAfter(new Date());
            //         if (sa && se) {
            //             vm.isShowSignUpBtn = true;
            //         } else {
            //             vm.isShowSignUpBtn = false;
            //         }
            //     }
            //     // this.$store.
            //     this.$store.commit('activity/setJumpUrl', this.activity.jumpUrl);
            //
            //     vm.timeSlotList = []
            //     let tArr = [];
            //     if (vm.activity.timeSlot) {
            //         tArr = vm.activity.timeSlot.split(/[\s\n]/)
            //         tArr.forEach(item => {
            //             vm.timeSlotList.push({
            //                 name: item
            //             })
            //         })
            //     }
            //
            //     // vm.timeSlotList.forEach(item => {
            //     //
            //     //     item.name = item;
            //     // })
            //     // console.log('时段：' + vm.timeSlotList)
            //     console.log('时段：' + vm.timeSlotList)
            //
            // }).finally(() => {
            //
            // });
        },
        saveSignUp() {
            if (JSON.stringify(this.member) === '{}') {
                return;
            }
            if (this.member && !this.member.isAuthentication) {
                this.isShowCert = true;
                return;
            }
            var p = 0;
            if (this.activity.isSignUp && this.activity.signUpCost > 0) {
                p = this.activity.signUpCost;
            }
            this.$router.push({
                name: 'activeForm',
                params: {
                    id: this.id,
                    price: p,
                    isUpLoad: this.activity.isUploadPhoto
                }
            })
        },
        getMyMember() {
            var vm = this;
            vm.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                vm.member = {};
                vm.member = vm.$store.state.member.memberInfo;
            }).finally(() => {

            });
        },
        certificate() {
            this.$router.push({ path: '/character' })
        },
        checkMemberCanSignUp() {
            abp.ajax.post('/api/services/app/Activity/CheckMemberCanSignUp?activityId=' + this.id).then((res) => {
                this.canSingUp = res.data.result;
            })
        },
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        this.getActiveDetail();
        this.getMyMember();
        this.checkMemberCanSignUp();
        this.$store.commit('activity/setIsJumpStatus', false)
    }
}
